export const msalConfig = {
	auth: {
		clientId: 'c9a55f18-e6a1-4b09-a221-56e129106357',
		authority: 'https://login.microsoftonline.com/f2fda5e7-2ea1-450d-9fc1-2af5f8630095',
		redirectUri: '/login'
	},
	cache: {
		cacheLocation: 'localStorage', // This configures where your cache will be stored
		storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
	}
}

export const loginRequest = {
	// scopes: ['https://graph.microsoft.com/User.Read']
	scopes: ['openid', 'profile', 'User.Read']
}

export async function callMsGraph(accessToken) {
	const headers = new Headers()
	const bearer = `Bearer ${accessToken}`

	headers.append('Authorization', bearer)

	const options = {
		method: 'GET',
		headers: headers
	}

	return fetch('https://graph.microsoft.com/v1.0/me/', options)
		.then(response => response.json())
		.catch(error => console.log(error))
}
